import { FC } from 'react';

import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';

import { ConsumerWrapper } from '../../consumer-wrapper/consumer-wrapper';
import { DynamicPageLink } from '../../dynamic-page-link/dynamic-page-link';
import { MockLink } from '../../mock-link/mock-link';

interface Props {
   route?: string;
   id: string;
   isConsumer: boolean;
   label?: string | null;
   slug?: string;
   noFollow?: boolean;
   locale: string;
   index?: number;
}

export const ClickableProductProperty: FC<Props> = ({ route, id, index, isConsumer, slug, noFollow, label, locale }) => (
   <Typography component="span" variant="body">
      {(index ?? 0) > 0 && ' • '}
      <ConsumerWrapper
         isConsumer={isConsumer}
         renderConsumer={(children) => (
            <DynamicPageLink id={id} baseRoute={{ url: route, noFollow }} slug={slug} locale={locale}>
               {children}
            </DynamicPageLink>
         )}
         renderProducer={(children) => <MockLink>{children}</MockLink>}
      >
         {label}
      </ConsumerWrapper>
   </Typography>
);
